import { ProfileBonusInfoSection } from '@/flat-pages/bonuses/ui/profile-bonus-info-section';
import { BonusListSection } from '@/flat-pages/bonuses/ui/bonus-list-section';

interface BonusMainContentProps {
  isProfileBonusesPage: boolean;
  dataWelcomeAvailable: any;
  visibleFilters: { category: string; key: string }[];
  selectedTag: string | null;
  onFilterClick: (filter: string, index: number) => void;
  data: any[] | undefined;
  updateDate: () => Promise<void>;
  onBonusClick: (bonus: any) => void;
}

export const BonusMainContent = ({
  isProfileBonusesPage,
  dataWelcomeAvailable,
  visibleFilters,
  selectedTag,
  onFilterClick,
  data,
  updateDate,
  onBonusClick,
}: BonusMainContentProps) => {
  if (isProfileBonusesPage) {
    return <ProfileBonusInfoSection dataWelcomeAvailable={dataWelcomeAvailable} />;
  }

  return (
    <BonusListSection
      visibleFilters={visibleFilters}
      selectedTag={selectedTag}
      onFilterClick={onFilterClick}
      data={data}
      updateDate={updateDate}
      onBonusClick={onBonusClick}
    />
  );
};
